import React, { useState } from "react"
import { t } from "ttag"

import * as Styles from "./ResendMfaCodeButton.styles"

const TIMEOUT_IN_SECONDS = 30

export const ResendMfaCodeButton: React.FC<ResendMfaCodeButtonProps> = (props) => {
  const [ counter, setCounter ] = useState<number>(TIMEOUT_IN_SECONDS)

  const isCounterOngoing = counter > 0

  React.useEffect(() => {
    isCounterOngoing && setTimeout(() => setCounter(counter - 1), 1000)
  }, [ counter, isCounterOngoing ])

  return <Styles.TextButton
    onClick={() => !isCounterOngoing && onRetry()}
    $isDisabled={isCounterOngoing}
  >
    {t`Send a new code` + `${displayCounter()}`}
  </Styles.TextButton>

  function onRetry() {
    props.onRetry()
    setCounter(TIMEOUT_IN_SECONDS)
  }

  function displayCounter(): string {
    return isCounterOngoing ? ` (${counter.toString()} ${t`seconds`})` : ""
  }
}

interface ResendMfaCodeButtonProps {
  onRetry: () => void,
}
